import { render, staticRenderFns } from "./referralHome.vue?vue&type=template&id=8285dc80"
import script from "./referralHome.vue?vue&type=script&lang=js"
export * from "./referralHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports